




import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'


@Component
export default class Home extends Vue {
  @Getter('access') access
  @Getter('trialExpired', { namespace: 'user' }) trialExpired

  created() {
    this.$router.push({ name: this.access ? 'profile' : 'regular', query: this.$route.query })
  }
}
